export const _adr = {
  Root: "/react",
  Home: "/home",
  Management: "/Management",
  Managementshop: "/Managementshop",
  About: "/About",
  Agent: "/Agent",
  Login: "/Login",
  Otp: "/Otp",
  Forgetpassword: "/Forgetpassword",
  ConfirmOtp: "/ConfirmOtp",
  ChangePassword: "/ChangePassword",
};
